export async function registerSW() {
  if (!import.meta.env.PROD) return;
  
  // If service worker is disabled, unregister any existing SW and clear caches
  if (import.meta.env.VITE_ENABLE_SW !== "true") {
    console.info('[SW] Service worker disabled - unregistering any existing workers');
    await unregisterSW();
    return;
  }
  
  if (!("serviceWorker" in navigator)) return;

  try {
    const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
    if (reg.waiting) {
      reg.waiting.postMessage({ type: "SKIP_WAITING" });
    }

    reg.addEventListener("updatefound", () => {
      const nw = reg.installing;
      nw?.addEventListener("statechange", () => {
        if (nw.state === "installed" && navigator.serviceWorker.controller) {
          console.info("New version ready. Refresh to update.");
        }
      });
    });
  } catch (error) {
    console.error("SW registration failed", error);
  }
}

export async function unregisterSW() {
  if (!("serviceWorker" in navigator)) return;

  const regs = await navigator.serviceWorker.getRegistrations();
  await Promise.all(regs.map((reg) => reg.unregister()));

  if ("caches" in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
  }
}
